module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "onboarding-complete.e5cc6c89.png";